import _JSXStyle from "styled-jsx/style";
import PropTypes from 'prop-types';
import React from 'react';
const FileList = _ref => {
  let {
    children,
    className,
    dataTest = 'dhis2-uicore-filelist'
  } = _ref;
  return /*#__PURE__*/React.createElement("div", {
    "data-test": dataTest,
    className: "jsx-2770071620" + " " + (className || "")
  }, children, /*#__PURE__*/React.createElement(_JSXStyle, {
    id: "2770071620"
  }, ["div.jsx-2770071620{padding-top:4px;}", ".file-input+div.jsx-2770071620{padding-top:0;}"]));
};
FileList.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  dataTest: PropTypes.string
};
export { FileList };